"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rel = exports.rand = void 0;
var rand = function () { return Math.floor(Math.random() * 900000000 + 100000000); };
exports.rand = rand;
var rel = function (startTime) { return ((new Date().getTime() - startTime) / 1000).toFixed(1); };
exports.rel = rel;
